import React from 'react';
import { Download, Loader2 } from 'lucide-react';

export function ExportButtons({ analysisId, sectionKey, color, exporting, onDownload }) {
  return (
    <div className="flex items-center gap-1.5" data-testid={`section-download-${sectionKey}`}>
      {['docx', 'xlsx', 'pdf'].map(fmt => (
        <button
          key={fmt}
          onClick={() => onDownload(fmt, sectionKey)}
          disabled={!!exporting}
          className="relative flex items-center gap-1 font-body btn-press transition-all disabled:opacity-50"
          style={{
            fontSize: 10, fontWeight: 600, borderRadius: 'var(--radius-md)',
            padding: '5px 10px', border: `1px solid ${color}40`,
            color: color, backgroundColor: `${color}0A`,
          }}
          data-testid={`download-${sectionKey}-${fmt}-button`}
        >
          {exporting === `${sectionKey}-${fmt}` ? (
            <Loader2 size={11} className="animate-spin" />
          ) : (
            <Download size={11} />
          )}
          {fmt.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

export function FullExportBar({ exporting, onDownload }) {
  return (
    <div className="flex items-center gap-2">
      {['docx', 'xlsx', 'pdf'].map(fmt => (
        <button
          key={fmt}
          onClick={() => onDownload(fmt)}
          disabled={!!exporting}
          className="relative flex items-center gap-1.5 font-body btn-press transition-all disabled:opacity-60"
          style={{
            fontSize: 12, fontWeight: 600, borderRadius: 'var(--radius-md)',
            padding: '8px 16px', background: 'var(--green-700)', color: 'white',
          }}
          data-testid={`download-${fmt}-button`}
        >
          {exporting === `full-${fmt}` ? (
            <Loader2 size={14} className="animate-spin" />
          ) : (
            <Download size={14} />
          )}
          Full {fmt.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
